export default __webpack_public_path__ + "static/media/modal-cross.f16b62cf.svg";